import Vue from "vue"
import _ from "lodash"
import { fetchUserInventory } from "./inventory.apis"
import { ITEM_CATEGORIES, CURRENCY_TYPES } from "./inventory.constants"

const state = () => ({
  inventory: undefined,
})

const mutations = {
  SET_INVENTORY: (state, inventory) => {
    Vue.set(state, "inventory", inventory)
  },
  SET_CATEGORY_ITEMS: (state, { category, items }) => {
    Vue.set(state.inventory, category, items)
  },
  SET_PG_POINTS: (state, amount) => {
    Vue.set(state.inventory[ITEM_CATEGORIES.CURRENCY], CURRENCY_TYPES.PG_POINTS, amount)
  },
  ADD_PG_POINTS: (state, amount) => {
    Vue.set(
      state.inventory[ITEM_CATEGORIES.CURRENCY],
      CURRENCY_TYPES.PG_POINTS,
      _.get(state, [ITEM_CATEGORIES.CURRENCY, CURRENCY_TYPES.PG_POINTS], 0) + amount
    )
  },
  DEDUCT_PG_POINTS: (state, amount) => {
    Vue.set(
      state.inventory[ITEM_CATEGORIES.CURRENCY],
      CURRENCY_TYPES.PG_POINTS,
      _.get(state, [ITEM_CATEGORIES.CURRENCY, CURRENCY_TYPES.PG_POINTS], 0) - amount
    )
  },
  SET_PB_CREDIT: (state, amount) => {
    Vue.set(state.inventory[ITEM_CATEGORIES.CURRENCY], CURRENCY_TYPES.PB_CREDIT, amount)
  },
  ADD_PB_CREDIT: (state, amount) => {
    Vue.set(
      state.inventory[ITEM_CATEGORIES.CURRENCY],
      CURRENCY_TYPES.PB_CREDIT,
      _.get(state, [ITEM_CATEGORIES.CURRENCY, CURRENCY_TYPES.PB_CREDIT], 0) + amount
    )
  },
  DEDUCT_PB_CREDIT: (state, amount) => {
    Vue.set(
      state.inventory[ITEM_CATEGORIES.CURRENCY],
      CURRENCY_TYPES.PB_CREDIT,
      _.get(state, [ITEM_CATEGORIES.CURRENCY, CURRENCY_TYPES.PB_CREDIT], 0) - amount
    )
  },
}

const actions = {
  async loadInventory ({ state, commit, dispatch }, forceReload) {
    forceReload = forceReload || false
    if (!forceReload && state.inventory !== undefined) {
      return
    }

    if (!state.inventory) {
      commit("SET_INVENTORY", {})
    }

    try {
      const inventoryItems = await fetchUserInventory()
      inventoryItems.forEach(inventoryItem => {
        dispatch("addInventoryItem", inventoryItem)
      })
      // Send event to coaching widget to update inventory
      const event = new CustomEvent("userInventoryUpdated")
      document.dispatchEvent(event)
    } catch (error) {
      console.error("Failed to load user inventory.", error)
    }
  },
  addInventoryItem ({ state, commit }, inventoryItem) {
    const itemCategory = inventoryItem?.category
    if (!state.inventory[itemCategory]) {
      commit("SET_CATEGORY_ITEMS", {
        category: itemCategory,
        items: {},
      })
    }

    const itemType = inventoryItem?.type
    const amount = inventoryItem?.quantity || 0
    switch (itemCategory) {
      case ITEM_CATEGORIES.CURRENCY:
        switch (itemType) {
          case CURRENCY_TYPES.PG_POINTS:
            commit("ADD_PG_POINTS", amount)
            break
          case CURRENCY_TYPES.PB_CREDIT:
            commit("ADD_PB_CREDIT", amount)
            break
        }
        break
    }
  },
  async addPGPoints ({ commit, dispatch }, amount) {
    await dispatch("loadInventory")
    commit("ADD_PG_POINTS", amount)
  },
  async deductPGPoints ({ commit, dispatch }, amount) {
    await dispatch("loadInventory")
    commit("DEDUCT_PG_POINTS", amount)
  },
}

const getters = {
  getPGPoints: state => _.get(state.inventory, [ITEM_CATEGORIES.CURRENCY, CURRENCY_TYPES.PG_POINTS], 0),
  getPbCredit: state => _.get(state.inventory, [ITEM_CATEGORIES.CURRENCY, CURRENCY_TYPES.PB_CREDIT], 0),
  getPrimaryCreditCurrency: (state, getters) => {
    return getters.getPbCredit > 0
      ? CURRENCY_TYPES.PB_CREDIT
      : CURRENCY_TYPES.PG_POINTS
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/user/inventory/inventory.module.js